import { useScrollReveal } from 'shared/hooks/useScrollReveal';
import { renderTitle } from 'shared/utils/renderTitle';

interface PageHeaderProps {
  label?: string;
  title: string;
  titleHighlight?: string;
  description?: string;
  italic?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export function PageHeader({
  label,
  title,
  titleHighlight,
  description,
  italic,
  children,
  className,
}: PageHeaderProps) {
  const labelReveal = useScrollReveal({ animation: 'fade', delay: 0 });
  const headingReveal = useScrollReveal({ animation: 'float-up', delay: 120 });
  const descriptionReveal = useScrollReveal({ animation: 'float-up', delay: 240 });
  const childrenReveal = useScrollReveal({ animation: 'float-up', delay: 360 });

  return (
    <div className={className}>
      {label && (
        <span
          ref={labelReveal.ref}
          style={labelReveal.style}
          className="font-sans uppercase tracking-[0.3em] text-tertiary text-xs font-bold mb-6 block"
        >
          {label}
        </span>
      )}
      <h1
        ref={headingReveal.ref}
        style={headingReveal.style}
        className={`font-serif text-6xl md:text-8xl leading-tight mb-8 tracking-tighter${italic ? ' italic' : ''}`}
      >
        {renderTitle(title, titleHighlight)}
      </h1>
      {description && (
        <p
          ref={descriptionReveal.ref}
          style={descriptionReveal.style}
          className="font-sans text-xl text-on-surface-variant leading-relaxed max-w-2xl"
        >
          {description}
        </p>
      )}
      {children && (
        <div ref={childrenReveal.ref} style={childrenReveal.style}>
          {children}
        </div>
      )}
    </div>
  );
}
